export type { Chronicle } from "./types";
export { REGIONS, ERAS } from "./types";

import { britishIslesChronicles } from "./british-isles";
import { lowCountriesChronicles } from "./low-countries";
import { iberiaChronicles } from "./iberia";
import { franceChronicles } from "./france";
import { hreChronicles } from "./hre";
import { scandinaviaChronicles } from "./scandinavia";
import { italyChronicles } from "./italy";
import { balkansChronicles } from "./balkans";
import { easternEuropeChronicles } from "./eastern-europe";
import { panEuropeanChronicles } from "./pan-european";

export const chronicles = [
  ...lowCountriesChronicles,
  ...britishIslesChronicles,
  ...iberiaChronicles,
  ...franceChronicles,
  ...hreChronicles,
  ...scandinaviaChronicles,
  ...italyChronicles,
  ...balkansChronicles,
  ...easternEuropeChronicles,
  ...panEuropeanChronicles,
];
